import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import GoogleMapReact from "google-map-react";
import { mapStyles } from "./MapStyles.js";
import { StarPin } from "./StarPin";

const UserPin = () => {
  return (
    <div className={`relative text-blue-500 animate-bounce`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
};

const LocationPin = (props) => {
  const history = useHistory();
  //const [pinIsSelected, SetPinIsSelected] = React.useState(false);
  const navigateToVenue = () => {
    props.setDrawerOpen(true);
    props.setSelectedVenue(props.venueId);
    props.setMapCenter({
      lat: props.lat,
      lng: props.lng,
    });
    history.push(`/venues/${props.venueId}`);
  };
  return (
    <div
      className={`relative ${
        props.selectedVenue === props.venueId ? "ripple" : "animation-reset"
      }`}
    >
      <StarPin
        className={`h-8 w-8 razz transform transition relative cursor-pointer ${
          props.selectedVenue === props.venueId
            ? "h-10 w-10 opacity-100 scale-110 ping"
            : "opacity-75"
        }`}
        onClick={() => navigateToVenue()}
      />
    </div>
  );
};

const GoogleMapStyle = {
  styles: mapStyles,
};

export const GoogleMap = ({
  mapCenter,
  setMapCenter,
  mapQuery,
  zoomLevel,
  setSelectedVenue,
  selectedVenue,
  drawerOpen,
  setDrawerOpen,
  userPosition,
  setUserPosition,
}) => {
  const { data, loading, error } = useQuery(mapQuery);

  if (loading) {
    return "Loading...";
  }
  if (error) return `Error! ${error}`;

  let showsWithVenues = [];
  data.getVenues.data.forEach((venue) => {
    if (venue.shows.data.length > 0) {
      showsWithVenues.push(venue);
    }
  });

  return (
    <div className="w-full h-screen" data-testid="googleMap">
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_KEY }}
        center={mapCenter}
        mapCenter={mapCenter}
        defaultZoom={zoomLevel}
        options={GoogleMapStyle}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        onClick={() => setDrawerOpen(false)}
        gestureHandling={"greedy"}
        yesIWantToUseGoogleMapApiInternals
      >
        {showsWithVenues.map((pin) => (
          <LocationPin
            key={pin._id}
            lat={pin.lat}
            lng={pin.long}
            setSelectedVenue={setSelectedVenue}
            selectedVenue={selectedVenue}
            mapCenter={mapCenter}
            setMapCenter={setMapCenter}
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
            onClick={() => setDrawerOpen(true)}
            venueId={pin._id}
          />
        ))}
        <UserPin lat={userPosition[0]} lng={userPosition[1]} />
      </GoogleMapReact>
    </div>
  );
};
